module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    inventoty_tabs\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "申請承認（詳細）"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.localIsEditing
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showTable) ? _c('sub-table-temp-batch-import', {
    attrs: {
      "sessionId": _vm.sessionId,
      "allowCheckBox": _vm.showCheckBox
    },
    on: {
      "editing": _vm.isEditing
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4261f4a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0050_approval_history_detail.vue
// module id = 969
// module chunks = 0